import './common';
import {genRandStr, getEnv} from '../inc/js/utils';
import {post} from '../inc/js/ajax';
import {showMessages, fadeOutRemove, Popup, showAlert} from '../inc/js/dom_utils';

const debug = getEnv() === 'dev';

const main_form = document.getElementById('main-form');

if(debug) {
    document.getElementById('nom').value = 'Nom du responsable';
    document.getElementById('prenom').value = 'Prénom du responsable';
    document.getElementById('tel').value = '+3378544564646';
    document.getElementById('email').value = 'email_responsable_' + genRandStr(2) + '@gmail.com';
    document.getElementById('pwd1').value = "FNvNIGG3/kZSS9lVld/l";
    document.getElementById('pwd2').value = "FNvNIGG3/kZSS9lVld/l";
    document.getElementById('nom_agence-0').value = "Nom de l'agence";
    document.getElementById('tel_agence-0').value = "+3364566865346";
    document.getElementById('adresse-0').value = "Résidence les lilas\n14 Ave d'Avienne";
    document.getElementById('ville-0').value = "Toulon";
    document.getElementById('code_postal-0').value = "83000";
    document.getElementById('pays-0').value = "FR";
    document.getElementById('email-0').value = "email_agence_" + genRandStr(2) + "@gmail.com";
    document.getElementById('pwd1-0').value = "FNvNIGG3/kZSS9lVld/l";
    document.getElementById('pwd2-0').value = "FNvNIGG3/kZSS9lVld/l";
}

document.getElementById('add-agence').addEventListener('click', function(e) {
    // Simple clone
    const clone = document.getElementsByClassName('agence-data')[0].cloneNode(true);

    const i = genRandStr(6);
    ['email_code', 'id_franchise', 'nom_agence', 'tel_agence', 'adresse', 'code_postal', 'ville', 'pays', 'email', 'pwd1', 'pwd2'].forEach(key => {
	clone.querySelector('.' + key + ' label').htmlFor = key + '-' + i;
	const tag = {id_franchise: 'select', adresse: 'textarea', pays: 'select'}[key] || 'input';
	const input = clone.querySelector('.' + key + ' ' + tag);
	input.id = key + '-' + i;
	const value = debug ? input.value + (key === 'email' ? genRandStr(3) : '') : '';
	input.value = key === 'id_franchise' ? '1' : value;
    });

    document.getElementById('agences-data').appendChild(clone);
    clone.scrollIntoView({block: 'center'});

    handleTagNames();
});

document.getElementById('agences-data').addEventListener('click', async function(e) {
    const btn = e.target.closest('.del-agence');
    if(btn) {
	await fadeOutRemove(e.target.closest('.agence-data'));
	handleTagNames();
    }
});

main_form.addEventListener('submit', function(e) {
    e.preventDefault();
    // Submit depuis le form principal, on n'envoie pas d'éventuelles valeurs antérieures email_code
    this.querySelectorAll('input.email_code').forEach(input => input.value = '');
    submit.call(this);
});

async function submit() {
    const form_data = new FormData(this);

    // Gestion erreur si email identique indiqué plusieurs fois
    const emails = {};
    emails[form_data.get('email').trim().toLowerCase()] = true;	    // responsable
    // Pour les agences, plus simple d'aller piocher dans le DOM
    for(const input of document.querySelectorAll('#agences-data .email input')) {
	const email = input.value.trim().toLowerCase();
	if(emails[email]) {
	    showMessages(`<b>Erreur: il n'est pas permis d'utiliser le même email plusieurs fois dans le formulaire.</b><br>
		Veuillez corriger votre saisie: "${email}".`);
	    return;
	}
	emails[email] = true;
    };

    // Vérification si les différents passwords correspondent
    // Responsable
    const pwd1 = form_data.get('pwd1'), pwd2 = form_data.get('pwd2');
    let err = false;
    if(pwd1 !== pwd2) {
	document.getElementById('pwd2').setCustomValidity('Les mots de passe ne correspondent pas');
	err = true;
    }
    // Agences
    for(const cont of document.querySelectorAll('#agences-data .pwd-container')) {
	const pwd1 = cont.querySelector('.pwd1 input'), pwd2 = cont.querySelector('.pwd2 input');
	if(pwd1.value !== pwd2.value) {
	    pwd2.setCustomValidity('Les mots de passe ne correspondent pas');
	    err = true;
	}
    };
    if(err) {
	showMessages('Veuillez vérifier que les mots de passe indiqués soient identiques');
	return;
    }

    form_data.append('a', 'signup');
    const json = await post(form_data, {
	auth: false,
	return_all: true,
	msg_success: 'silent'
    });
    // response = "": succès (en attente de validation par admin) et on gère ici le message afin de le mettre dans alert_success
    // response = "email_code" (emails envoyés, affichage popup, user doit entrer les codes correspondants) et json.msg défini
    if(json.data === 'email_code') {
	showPopupEmailCode();
	showMessages(json.msg);
    } else {
	this.classList.remove('was-validated');
	this.reset();
	showAlert('success', "Votre compte a été créé avec succès.<br>Vous allez recevoir un email de confirmation.<br>Votre accès ne sera pleinement opérationnel qu'une fois qu'un administrateur vitroto aura validé votre demande et vous recevrez alors un 2ème email.", 'scroll');
    }
}

// Gestion password identiques, event par délégation
main_form.addEventListener('input', function(e) {
    const t = e.target;
    if(t.tagName !== 'INPUT' || !t.classList.contains('pwd')) return;
    const cont = t.closest('.pwd-container'), pwd1 = cont.querySelector('.pwd1 input'), pwd2 = cont.querySelector('.pwd2 input');
    if(pwd2.validity.customError && pwd1.value === pwd2.value) pwd2.setCustomValidity('');
});


// #############
// HELPERS
// #############

function showPopupEmailCode() {
    if(showPopupEmailCode.popup === null) {
	// 1: Au 1er appel, générer le popup, mais sans body qui peut être variable selon le nombre d'agences
	const p = showPopupEmailCode.popup = Popup.get('popup-email-code', {
	    backdrop: 'static',
	    size: 'lg',
	    html_header: "<h3>Validation des emails</h3>",
	    html_footer: '<button form="form-email-code" class="btn btn-primary">Soumettre</button>'
	});

	p.setEvents([
	    {selector: null, type: 'submit', listener: async function(e) {
		const form = e.target;
		if(form.tagName !== 'FORM') return;

		e.preventDefault();
		// Copie des codes vers le form d'origine qui en seront supprimés au prochain submit depuis main_form
		form.querySelectorAll('input[name="email_code"]').forEach(input =>  {
		    main_form.querySelector(input.dataset.selector).value = input.value;
		});
		await submit.call(main_form);
		p.hide();
	    }}
	]);
    }

    const p = showPopupEmailCode.popup;

    // 2: mise en place du body
    p.setBody(getPopupBody());

    // 3: reset
    p.findAll('input[name="email_code"]').forEach(input => input.value = '');
    document.getElementById('form-email-code').classList.remove('was-validated');	// Retirer id du form, changer selecteur

    // 4: Go !
    p.show();
};
showPopupEmailCode.popup = null;

function getPopupBody() {
    // Détaché de showPopupEmailCode() uniquement pour plus de clarté
    // Pour chaque input email_code de main_form (1 pour responsable, 1 pour chaque agence):
    // - insertion input dans popup
    // - cet input conserve le selecteur pour update main_form plus simple
    // 1: responsable
    const email = document.getElementById('email').value;
    let body = `<form id="form-email-code" class="needs-validation" novalidate style="overflow-y: auto; max-height: 25rem;">
	<h3 class="h6">Merci de renseigner les codes à 6 chiffres que vous allez recevoir à chacun des emails utilisés</h3>
	<hr>
	<ul>
	    <li class="mb-3">
		<label class="mb-2 align-top" for="email_code">Code pour le <u>responsable d'agence(s)</u>: «&nbsp;<i>${email}</i>&nbsp;»</label>
		<input type="text" id="email_code" name="email_code" inputmode="numeric" class="form-control w-auto m-auto" required minlength="6" maxlength="6" pattern="\\d*" autocomplete="one-time-code" data-selector="input[name=email_code]">
		<div class="invalid-feedback">Veuillez indiquer un code à 6 chiffres</div>
	    </li>`;
    // 2: agences
    main_form.querySelectorAll('.agence-data').forEach((agence, i) => {
	const email = agence.querySelector('.email input').value;
	const id = 'email_code-' + genRandStr(6);	// Ou équivalent: "email_code{$i}"
	body += `<li class="mb-3">
	    <label class="mb-2 align-top" for="${id}">Code pour <u>l'agence</u>: «&nbsp;<i>${email}</i>&nbsp;»</label>
	    <input type="text" id="${id}" name="email_code" inputmode="numeric" class="form-control w-auto m-auto" required minlength="6" maxlength="6" pattern="\\d*" autocomplete="one-time-code" data-selector='input[name="agences[${i}][email_code]"]'>
	    <div class="invalid-feedback">Veuillez indiquer un code à 6 chiffres</div>
	</li>`;
    });

    body += '</ul></form>';

    return body;
}

// Réorganiser les attributs name des inputs à l'ajout - delete, afin de recevoir ça groupé par agences sur le serveur
// ie: 1ère agence: name="agences[0][name]", 2ème agence: name="agences[1][name]" etc.
const handleTagNames = () => {
    document.querySelectorAll('.agence-data').forEach((el, i) => {
	['email_code', 'id_franchise', 'nom_agence', 'tel_agence', 'adresse', 'code_postal', 'ville', 'pays', 'email', 'pwd1', 'pwd2'].forEach(key => {
	    const tag = {id_franchise: 'select', adresse: 'textarea', pays: 'select'}[key] || 'input';
	    el.querySelector('.' + key + ' ' + tag).name = 'agences[' + i + '][' + key + ']';
	});
    });
};

